// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container-bYnTX {
  width: 100%;
  height: 100%;
  display: block;
  overflow: auto;
  border-collapse: separate;
  border-spacing: 0px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/table/table.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".container {\n  width: 100%;\n  height: 100%;\n  display: block;\n  overflow: auto;\n  border-collapse: separate;\n  border-spacing: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `table-container-bYnTX`
};
export default ___CSS_LOADER_EXPORT___;
